/* Awish predictive search panel — open/close + empty-state toggle.
   The actual search (live suggestions + products) is handled by Dawn's
   <predictive-search> (Shopify Predictive Search API). This only wires the
   header pills to open the panel (no redirect) and toggles empty vs results. */
(function () {
  var panel = document.querySelector('[data-awish-search]');
  if (!panel) return;

  var input = panel.querySelector('#awish-search-input');
  var clearBtn = panel.querySelector('.awish-search__clear');
  var header = document.querySelector('.section-header') || document.querySelector('header');

  function setHeaderH() {
    var h = header ? header.getBoundingClientRect().height : 64;
    panel.style.setProperty('--awish-header-h', Math.round(h) + 'px');
  }

  function syncQuery() {
    var v = (input && input.value || '').trim();
    panel.classList.toggle('has-query', v.length > 0);
    if (clearBtn) clearBtn.classList.toggle('is-hidden', v.length === 0);
  }

  function open() {
    setHeaderH();
    if (panel.classList.contains('is-open')) { input && input.focus(); return; }
    panel.hidden = false;
    void panel.offsetHeight; // reflow so the transition runs
    panel.classList.add('is-open');
    document.documentElement.classList.add('awish-search-open');
    syncQuery();
    setTimeout(function () { input && input.focus(); }, 70);
  }

  function close() {
    if (!panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('awish-search-open');
    setTimeout(function () { panel.hidden = true; }, 300);
  }

  // Open from the existing header search pills — without redirecting
  function wireOpen(el, preventClick) {
    if (!el) return;
    el.addEventListener('focus', open);
    el.addEventListener('click', function (e) { if (preventClick) e.preventDefault(); open(); });
  }
  wireOpen(document.getElementById('Search-In-Header-Desktop'), false);
  wireOpen(document.querySelector('.awish-mobile-search-input'), false);
  wireOpen(document.querySelector('.awish-search-trigger'), true);

  // Stop the original pill forms from redirecting; open the panel instead
  ['.awish-desktop-search .search-form', '.awish-mobile-search-form'].forEach(function (sel) {
    var f = document.querySelector(sel);
    if (f) f.addEventListener('submit', function (e) { e.preventDefault(); open(); });
  });

  // Close: X buttons, overlay, Escape
  panel.querySelectorAll('[data-awish-search-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Empty-state vs predictive results
  if (input) input.addEventListener('input', syncQuery);
  var form = panel.querySelector('form');
  if (form) form.addEventListener('reset', function () {
    setTimeout(function () { syncQuery(); input && input.focus(); }, 0);
  });

  window.addEventListener('resize', function () {
    if (panel.classList.contains('is-open')) setHeaderH();
  });
})();
